/**
 *Outlines selector icon:: Buildings outlines.
 * Uses `currentColor` for both stroke and hover fill.
 */
export function BuildingOutlinesIcon() {
  return (
    <svg viewBox="0 0 100 100" width="100%" height="100%" aria-hidden="true">
      <style>{`
        .blyr_ct  { fill: none; stroke: currentColor; stroke-width: 1; pointer-events: none; }
        .blyr_bg  { fill: rgba(0,0,0,0); stroke: currentColor; stroke-width: 1; }
        .blyr_bg:hover { fill: currentColor; fill-opacity: 0.3; stroke: currentColor; stroke-width: 2; }
      `}</style>
      <path className="blyr_bg" d="M14 29v42l36 21 36 -21v-42l-36 -21z" />
      <path className="blyr_ct" d="M50 50l36 -21 M14 29l36 21 M50 92v-42 M50 50l-36 -21 M50 50v42 M86 29l-36 21 " />
    </svg>
  )
}
